import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {FormattedMessage} from 'react-intl';
import messages from '../../../res/translations/messages';

const Error404 = () => (
    <div className="pt-3">
        <h1><FontAwesomeIcon icon="exclamation-triangle" /> <FormattedMessage {...messages.errors.error404} /></h1>
    </div>
);

export default Error404;
